import React, { useCallback, useMemo, useState } from "react";
import CabInfoListUI from "../CabInfoList/CabInfoListUI";
import * as S from "./CabListItem.styles";
import Button from "../../../../core-components/Button/ButtonUI";
import ToolTipUI from "../../../../../stories/core-components/ToolTip/ToolTipUI";
import DiscountOverlayUI from "../../../../../stories/core-components/DiscountOverlay/DiscountOverlayUI";
import PremiumFeaturesUI from "../PremiumFeatures/PremiumFeaturesUI";
import { CTA_TYPE, getActionNameForOmniture, pushOmniEvents } from "../../../../../shared/utils/omni-utils";
import { gcTripCategoryScreen, getCtaProperty, getRouteDetails, getTripDays } from "../../../../../shared/config/omni";
import { ecoFriendlyImage } from "../../../../../shared/config/constants";
import BluSmartBanner from "../../../../../shared/containers/BluSmartBanner/BluSmartBanner";
import dateFormat from 'dateformat'
import { dateTypeFormat, LOCAL_RENTAL, ROUND_TRIP, RouteCountry, timeTypeFormat, CABS_REVIEW_ROUTE, CAB_LIST_ITEM, CAB_SELECT } from "../../../../../shared/utils/util-constants";
import { useSelector } from "react-redux";
import { SeoMetaSelector } from "../../../../../shared/pages/SeoPage/redux/selector";

interface IDetails {
  data: string;
  icon?: string;
  tag?: string;
}

interface IFeat {
  text: string;
  icon: string;
}

interface IFeatures {
  title: string;
  color: Array<string>;
  feature: Array<IFeat>;
}

interface ICabListItem {
  h                 : string;
  fuel              : { t?: string; bc?: string, s_i: string };
  review            : { t?: string; bc?: string };
  review_str        : string;
  h_p               : string;
  c_a               : Array<{ t: string; icon: string }>;
  is_ryde           : boolean;
  s_i               : string;
  pay_info          : IPayInfo;
  details           : Array<IDetails>;
  naviagteToReview  : Function;
  key               : string;
  pc                : string;
  caData            : Ica;
  itemKey           : string;
  h_g               : Array<string>;
  c_a_f             : IFeatures;
  t_c              ?: any
  c_d              ?: any
  position         ?: number
  commonData       ?: any
  ryde_icon_url    ?:string;
  supplierId       ?: string
  dbg              ?: any
  packageId        ?: string
  isSeo            ?: boolean
  minFareSchema    ?: number
  aggregateRating  ?: { review: number, ratings: number }
  addonString      ?: string
}
interface Ica {
  msg: string;
  ic: string;
}
interface IPayInfo {
  t: string;
  so_price: string;
  price: string;
  price_msg: string;
  price_pers: string;
  cta_text: string;
  tool_tip: string;
  sod?: number;
  sfd?: number;
  per_off?: number;
  pd?: number;
  od?: number;
  pc?: string;
}

const CabListItemUI: React.FC<ICabListItem> = ({
  h = "",
  fuel = {},
  review = {},
  review_str = "",
  h_p = "",
  c_a = [],
  is_ryde = false,
  s_i = "",
  pay_info = {},
  details = [],
  naviagteToReview = () => {},
  itemKey = "",
  pc = "",
  caData = {},
  h_g = [],
  c_a_f = {},
  ryde_icon_url='',
  t_c = {},
  c_d = [],
  position = 0,
  commonData = {},
  supplierId = "",
  dbg = {},
  packageId = "",
  isSeo = false,
  aggregateRating,
  minFareSchema,
  addonString = ""
}) => {
  const {
    t = "",
    so_price = "",
    price = "",
    price_msg = "",
    price_pers = "",
    cta_text = "",
    tool_tip = "",
    per_off = 0,
    sod = 0,
    pd = 0,
    sfd = 0,
    od = 0,
  } = pay_info;
  const seoMeta = useSelector(SeoMetaSelector);
  const [tooltip, setToolTip] = useState(false);
  const [cTooltip, cSetToolTip] = useState("");
  const [discountOverlay, setDiscountOverlay] = useState(false);
  
  let top = 50;
  if (sod && sod > 0) top += 35;
  if (sfd && sfd > 0) top += 35;
  if (pd && pd > 0) top += 35;
  if (od && od > 0) top += 35;

  const onCabSelection = (selectionDetails: any) => {
    let fuelType : string = ""
    let skuPosition : string = `${position}`

    if (c_d?.length) {
      const fuel = c_d.find(detls => detls?.key === selectionDetails?.key)?.fuel
      fuelType = fuel?.t || ""

      if (c_d?.length > 1) {
        const index : number = (c_d || []).findIndex(detls => detls?.key === selectionDetails?.key)
        if (index !== -1) {
          skuPosition = `${position}:${index}`
        }
      }
    }

    const skuDetails = `${t_c?.cat} | ${t_c?.t} ${t_c?.st} | ${h_p} | is_ryde : ${is_ryde} | fuelType : ${fuelType}`
    const eventDetails = {
      cta: getCtaProperty(getActionNameForOmniture(gcTripCategoryScreen, CAB_SELECT), CTA_TYPE.BUTTON, CAB_LIST_ITEM, CABS_REVIEW_ROUTE),
      productListItems: [{
        SKU: skuDetails
      }],
      search: {
        searchRank: skuPosition,
        searchId: commonData?.dispatch_search_id
      },
      booking: {
        tripType: commonData?.trip_type,
        routeCity: commonData?.trip_type === LOCAL_RENTAL ? getRouteDetails(commonData?.source_city, '') : getRouteDetails(commonData?.source_city, commonData?.destination_city),
        routeState: commonData?.trip_type === LOCAL_RENTAL ? getRouteDetails(commonData?.source?.State, '') : getRouteDetails(commonData?.source?.State, commonData?.destination?.State),
        routeCountry: RouteCountry,
        departureDate: `${dateFormat(commonData?.start_time, dateTypeFormat)}`,
        departureTime: `${dateFormat(commonData?.start_time, timeTypeFormat)}`,
        daysToTrip: getTripDays(new Date().toString(), commonData?.start_time)
      }
    }

    if (commonData?.trip_type === LOCAL_RENTAL && packageId) {
      eventDetails.booking["packageId"] = packageId
    }

    if (commonData?.trip_type === ROUND_TRIP) {
      eventDetails.booking["returnDate"]  = `${dateFormat(commonData?.end_time, dateTypeFormat)}`
      eventDetails.booking["returnTime"]  = `${dateFormat(commonData?.end_time, timeTypeFormat)}`
      eventDetails.booking["duration"]    = getTripDays(commonData?.start_time, commonData?.end_time)
    }

    pushOmniEvents({eventName: "cabsSearchClickthrough", details: eventDetails})
    naviagteToReview(selectionDetails)
  }
  
  const isBluSmart = useMemo(() => {
    let isBluSmart : boolean = (function(){
      let isBluSmartCab = false
      if (supplierId && supplierId?.length && dbg && (dbg?.message || dbg?.times)) isBluSmartCab = true
      return isBluSmartCab
    })()
    return isBluSmart
  }, [])

  const addProductSchema = useCallback(
    () => {
      let shouldAddProductSchema = false
      if (isSeo && position === 0 && ((aggregateRating && Object.keys(aggregateRating)?.length > 0) || minFareSchema > 0)) shouldAddProductSchema = true
      return shouldAddProductSchema
    },[]
  );

  const showAggregateRating = useCallback(
    () => {
      let shouldShowAggregateRating = false
      if (isSeo && position === 0 && aggregateRating && Object.keys(aggregateRating)?.length > 0) shouldShowAggregateRating = true
      return shouldShowAggregateRating
    },[]
  );

  return (
    <>
      <S.ItemWrapper isBluSmart={isBluSmart} {...(addProductSchema() ? {itemType:"https://schema.org/Product", itemScope: true} : {})}>
        {isSeo && seoMeta && seoMeta?.h1_title?.length > 0 ? (
          <meta itemProp="name" content={seoMeta?.h1_title} />
        ) : null }
        
        <S.ItemLeftCont>
          <div className="itemLeftHead">
            <div className="makeFlex hrtlCenter">
              {isBluSmart ? (
                <>
                  <S.ElectricVehicleImg src={ecoFriendlyImage}/>
                </>
              ) : (
                <>
                  {h_g?.length > 0 ? (
                    <S.EngineType primaryColor={h_g?.[0]} secondaryColor={h_g?.[1]}></S.EngineType>
                  ) : <S.EngineType></S.EngineType>}
                </>
              )}
              <span className="cabTitle">{h}</span>
            </div>
            <div {...(showAggregateRating() ? {itemType:"https://schema.org/AggregateRating", itemScope: true, itemProp:"aggregateRating"} : {})}>
              {showAggregateRating() ? (
                <>
                  <meta itemProp="reviewCount" content={`${aggregateRating?.ratings}`} />
                  <meta itemProp="ratingValue" content={`${aggregateRating?.review}`} />
                  <span itemProp="itemReviewed" itemScope itemType="https://schema.org/Car">
                    <meta itemProp="name" content={seoMeta?.h1_title} />
                  </span>
                </>
              ) : null}
    
              {review_str ? <span className="reviews">{review_str}</span> : null}
              {review?.t ? (
                <S.RatingTag bc={review?.bc}>
                  <span>{`${review?.t} / 5`}</span>
                </S.RatingTag>
              ) : null}
            </div>
          </div>
          {c_a?.length ? (
            <div className="safetyMeasure">
              <ul className="safetyMeasureList">
                {c_a.map(({ icon = "", t = "", key }, index) => {
                  return (
                    <li
                      key={`safety${index}`}
                      onMouseOver={() => cSetToolTip(key)}
                      onMouseOut={() => cSetToolTip("")}
                    >
                      <img src={icon} style={{ height: "15px" }} alt="cab tags" />
                      <span>{t}</span>
                      {cTooltip && key === cTooltip && caData?.[cTooltip] ? (
                        <S.ToolTip>
                          <ToolTipUI
                            title={caData[cTooltip].ic}
                            data={caData[cTooltip].msg}
                            showIcon={false}
                            beforeLeft={"4rem"}
                            bgColor={"#e9f6ea"}
                            borderColor={"#afdfb3"}
                            color={"#2bac36"}
                          />
                        </S.ToolTip>
                      ) : null}
                    </li>
                  );
                })}
              </ul>
              {is_ryde ? (
                <ul className="rydeMeasureList">
                  <li>
                    <img src={ryde_icon_url} style={{ height: "40px" }} alt="ryde" />
                  </li>
                </ul>
              ) : null}
            </div>
          ) : (is_ryde ? (
            <div className="safetyMeasure">
              <ul className="rydeMeasureList">
                <li>
                  <img src={ryde_icon_url} style={{ height: "40px" }} alt="ryde" />
                </li>
              </ul>
            </div>
          ) : null)}
          {c_a_f?.feature?.length > 0  ? <PremiumFeaturesUI {...c_a_f}  is_ryde={is_ryde} /> : null}
          {details?.length ? <CabInfoListUI details={details} /> : null}
          {s_i ? <div className="infoText">{s_i}</div> : null}
          {isBluSmart ? (
            <BluSmartBanner dbgData={dbg}/>
          ) : null}
        </S.ItemLeftCont>
        <S.ItemRightCont {...(position === 0 && minFareSchema > 0 ? {itemType:"https://schema.org/AggregateOffer", itemScope: true, itemProp:"offers"} : {})}>
          {
            position === 0 && minFareSchema > 0 ? (
              <>
                <meta itemProp="lowPrice" content={`${minFareSchema}`} />
                <meta itemProp="priceCurrency" content="INR" />
              </>
            ) : null
          }
          {h_p ? <p className="fcText">{h_p}</p> : null}
          <S.ItemRightFooter>
            {!!per_off && (
              <div
                className="priceDtl posRel cursor"
                onMouseOver={() => setDiscountOverlay(true)}
                onMouseOut={() => setDiscountOverlay(false)}
              >
                <div className="discount">
                  <p className="text">{`${per_off}% off`}</p>
                  <div className="circle"></div>
                </div>
                <div className="shape"></div>
                {discountOverlay && (
                  <S.ToolTip>
                    <S.DiscountOverlayWrapper top={`-${top}px`}>
                      <DiscountOverlayUI {...pay_info} />
                    </S.DiscountOverlayWrapper>
                  </S.ToolTip>
                )}
              </div>
            )}
            <p className="priceDtl">
              {so_price ? (
                <span className="actualPrice">
                  <span className="giRupee">₹</span>
                  {so_price}
                </span>
              ) : null}
              {price ? (
                <span className="discountedPrice">
                  <span className="giRupee">₹</span>
                  {price}
                </span>
              ) : null}
            </p>
            {price_msg ? <p className="inclusive">{price_msg}</p> : null}
            <span onClick={() => onCabSelection({ key: itemKey, pc,is_ryde })}>
              <Button margin="0 0 0.7rem 0" name={t} />
            </span>
            {price_pers ? (
              <>
                <p
                  className="bpgText"
                  dangerouslySetInnerHTML={{ __html: price_pers }}
                ></p>
                <div
                  className="knowMore"
                  style={{ position: "relative" }}
                  onMouseOver={() => setToolTip(true)}
                  onMouseOut={() => setToolTip(false)}
                >
                  {` ${cta_text}`}
                  {tool_tip && tooltip ? (
                    <div style={{ position: "absolute", marginTop: "-17px" }}>
                      <ToolTipUI
                        title={""}
                        data={tool_tip}
                        showIcon={false}
                        beforeLeft={"13rem"}
                      />
                    </div>
                  ) : null}
                </div>
              </>
            ) : null}
          </S.ItemRightFooter>
        </S.ItemRightCont>
      </S.ItemWrapper>
      {addonString?.length ? (
        <S.AddonCont>
          {commonData?.travel_addon_img?.length ? (
            <img src={commonData?.travel_addon_img} style={{ height: "16px" }} alt="cab addons" />
          ) : null}
          <div 
            style={{color: "#00a2ad"}}
            dangerouslySetInnerHTML={{
              __html: addonString
            }}>
          </div>
        </S.AddonCont>
      ) : null}
    </>
  );
};

export default React.memo(CabListItemUI);
